import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
  // FaCog, 
  FaUser, 
  FaSignOutAlt
 } from "react-icons/fa"; // Import icons
import "./NavbarInventory.css";
import logo from "./logo512.png";
// import Profile from '../../Images/Phumulani_Ntuli_phototaken_by_ThysDullart.png'



function NavbarInventory() {
  // const [click, setClick] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownTimeout, setDropdownTimeout] = useState(null);
  const [, setUser] = useState(null); // State to store user data
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem('userData'));


    // Fetch user data (including profile picture)
    useEffect(() => {
      const fetchUserData = async () => {
        try {
          const response = await fetch("/api/user"); // Replace with your API endpoint
          const data = await response.json();
          setUser(data);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };
  
      fetchUserData();
    }, []);


  const handleLogout = () => {
    localStorage.removeItem("token"); // Clear the token
    navigate("/login"); // Redirect to login page
  };

  const handleMouseEnter = () => {
    if (dropdownTimeout) {
      clearTimeout(dropdownTimeout);
      setDropdownTimeout(null);
    }
    setDropdownOpen(true);
  };
  
  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setDropdownOpen(false);
    }, 300); // 300ms delay
    setDropdownTimeout(timeout);
  };


return (
  <>
    <nav className="nav">
      {/* Logo on the Left */}
      <div id="logo">
        <Link to="#">
          <img src={logo} alt="Studio Logo" loading="lazy" />
        </Link>
      </div>

      {/* Profile Picture on the Right */}
      <div
        className="profile-profile"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* <img
          src={Profile}
          alt="Profile"
          className="profile-picture"
        /> */}

            <img 
            src={userData.imgurl || logo} // Use default image if imgurl is not provided
            alt="Profile" 
            // style={{ width: '100px', height: '100px', borderRadius: '50%' }} 
            className='profile-picture'
            />
        {dropdownOpen && (
          <div className="dropdown-menu">

            <div className="dropdown-item" onClick={() => navigate("/profile")}>
              <FaUser className="dropdown-icon" />
              <span>Profile</span>
            </div>

            <div className="dropdown-item" onClick={handleLogout}>
              <FaSignOutAlt className="dropdown-icon" />
              <span>Logout</span>
            </div>
          </div>
        )}
      </div>
    </nav>
  </>
);

}



export default NavbarInventory;
